import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AreaType } from '../../_core/interfaces/IAreaType';
import { ToolboxItemService } from '../../_core/services/toolbox-item.service';
import { ProjectService } from '../../_core/services/project.service';
import { AuthService } from 'src/app/_core/services/auth.service';
import { AppMode, AREA_LABELS, SvgZoomParams, Tags } from 'src/app/_core/constants/constants';
import { CrmService } from 'src/app/_core/services/crm.service';
import { environment } from 'src/environments/environment';
import { Common } from 'src/app/_core/models/common';
import { ApiService } from 'src/app/_core/services/api.service';
import { IPoint } from 'src/app/_core/interfaces/IPoint';
import { IBarLine } from 'src/app/_core/interfaces/IBarLine';
import { LayerLevel } from 'src/app/_core/interfaces/LayerLevel';
import { BomPopupComponent } from '../bom-popup/bom-popup.component';
import { IPrintoutFile, PrintoutType } from 'src/app/_core/models/boms/bom.model';
import { v4 as uuidv4 } from 'uuid';
import { StorageService } from 'src/app/_core/services/storage.service';
import { ProjectData } from 'src/app/_core/project-data';
import { PrintChannel } from '../svg-component/svg.component';
import { ISaleOfferResponse } from 'src/app/_core/interfaces/ICRMIntegration';

@Component({
	selector: 'app-areas',
	templateUrl: './areas.component.html',
	styleUrls: ['./areas.component.css']
})
export class AreasComponent implements OnInit {
	@ViewChild('bom') bom: BomPopupComponent;
	@Output() areaClick = new EventEmitter<AreaType>();
	@Output() zoomClick = new EventEmitter<number>();
	@Output() undoClick: EventEmitter<boolean> = new EventEmitter();
	@Output() redoClick: EventEmitter<any> = new EventEmitter();
	@Output() resetClick: EventEmitter<any> = new EventEmitter();
	@Output() barSelection: EventEmitter<any> = new EventEmitter();
	@Output() waitVisible: EventEmitter<boolean> = new EventEmitter();
	@Output() viewChange: EventEmitter<'Design' | 'Options'> = new EventEmitter();
	@Input() selected: AreaType;
	@Input() priceValue: number;
	@Input() showPrice: boolean;
	@Input() undoDisabled: boolean;
	@Input() redoDisabled: boolean;
	
	selectedView: 'Design' | 'Options' = 'Design';
	currentZoom: number = SvgZoomParams.INIT;

	zoomInLabel: string = $localize`:Toolbar|'Zoom in' button tooltip:Zoom in`;
	zoomOutLabel: string = $localize`:Toolbar|'Zoom out' button tooltip:Zoom out`;
	zoomResetLabel: string = $localize`:Toolbar|'Reset layout' button tooltip:Reset layout`;
	undoLabel: string = $localize`:Toolbar|'Undo' button tooltip:Undo`;
	redoLabel: string = $localize`:Toolbar|'Redo' button tooltip:Redo`;
	rewindLabel: string = $localize`:Toolbar|'Rewind' button tooltip:Rewind`;
	printLabel: string = $localize`:Toolbar|'Print project' button tooltip:Print project`;
	closeLabel: string = $localize`:Toolbar|'Close Designer' button tooltip:Close Designer`;
	layersLabel: string = $localize`:Common|Layers:Layers`;
	

	scale: number = 0.02;
	rightCoordinates: IPoint[] = [];
	roofCoordinates: IPoint[] = [];
	barLines: IBarLine[] = [];
	projectWidth: number;

	layerInside: boolean = true;
	layerMiddle: boolean = true;
	layerOutside: boolean = true;
	layerDimensions: boolean = false;

	showValidationPopup: boolean = false;

	requestDialog: boolean = false;
	offerResponse: ISaleOfferResponse;
	exportInProgress: boolean = false;

	get validationIcon() {
		return this.projectService.errors?.length > 0 ? this.projectService.svgIcons.xCircleIcon : this.projectService.svgIcons.checkCircleIcon;
	}

	constructor(
		public toolBSrvc: ToolboxItemService,
		public projectService: ProjectService,
		private authService: AuthService,
		public crmService: CrmService,
		private api: ApiService,
		private storageService: StorageService) { }
	 
	ngOnInit(): void {
		var z = SvgZoomParams.INIT;
		var s = localStorage.getItem("zoom");
		if (s) {
			z = parseFloat(s);
		}
		this.currentZoom = z;
		this.zoomClick.emit(z);

		this.projectService.projectReady.subscribe(p => {
			if (p) {
				if (this.projectService.erpExportMode) {
					this.bom.togglePopup(true);
				}
			}
		});

		this.projectService.printoutReady.subscribe((printout: { channel: PrintChannel, file: IPrintoutFile }) => {
			if (printout.channel == PrintChannel.CRMAPI) {
				this.checkImagesAndSendToCRM(printout.file);
			}
		});
		
	}


	areaSymbol(type: string) {
		var i = Object.values(AreaType).indexOf(AreaType[type]);
		return AREA_LABELS[window.document.documentElement.lang][i-1];
	}

	private checkImagesAndSendToCRM(printout: IPrintoutFile) {
		if (printout != null && printout.type != PrintoutType.None) {
			this.images.push({ type: PrintoutType[printout.type], content: printout.content });
		}

		if (this.expectedImages == 0 || this.images.length === this.expectedImages) {
			var model = this.storageService.storeProject();
			var toSend: ProjectData = {
				projectInfo: this.projectService.info,				
				designerData: model,
				printoutFiles: this.images
			};
			this.waitVisible.emit(true);
			this.api.exportToCRM(this.projectService.productId, toSend, this.projectService.brandName).subscribe(e => {				
				this.offerResponse = e.response;
				if (e.response.saleOfferTotalNetPrice > 0 && !e.response.currency) {
					e.response.currency = "EUR";
				}
				this.exportInProgress = false;
				this.waitVisible.emit(false);
				this.requestDialog = true;
			});

		}
	}

	private expectedImages: number = 0;
	private images: IPrintoutFile[] = [];

	onCRMExport() {
		const requestId = uuidv4();
		this.exportInProgress = true;
		this.images = [];
		this.expectedImages = this.projectService.calculateExpectedImages();

		setTimeout(() => {				
			this.selectView('Design');
		}, 0);

		setTimeout(() => {
			this.projectService.printProjectSubj.next({ requestId, channel: PrintChannel.CRMAPI });      
		}, 100);
	}

	get roofPath(){
		return ProjectService.getPath(this.roofCoordinates);
	}

	get rightPath(){
		return ProjectService.getPath(this.rightCoordinates);
	}

	selectView(view: 'Design' | 'Options') {
		this.selectedView = view;
		this.viewChange.emit(view);
	}
	
	selectArea(type: string) {
		if (this.selected == AreaType[type]) {
			return;
		}
		this.selected = AreaType[type];
		this.areaClick.emit(AreaType[type]);

		this.areaSymbol(this.selected);
	}

	onPrint(){
		setTimeout(() => {				
			this.selectView('Design');
		}, 0);

		setTimeout(() => {				
			this.projectService.printProjectSubj.next({
				requestId: uuidv4(),
				channel: PrintChannel.Browser
			});
		}, 100);
	}


	onZoom(factor: number) {
		if (factor == 0) {
			this.currentZoom = 1;
			localStorage.setItem("zoom", "1");
			this.resetClick.emit();
		} else {
			this.currentZoom += factor * SvgZoomParams.STEP;
			localStorage.setItem("zoom", Common.round(this.currentZoom).toString());
			this.zoomClick.emit(this.currentZoom);
		}
	}

	currentZoomPerc(factor: number) {
		var tempZoom = this.currentZoom + factor * SvgZoomParams.STEP;
		return Math.round(100 + ((tempZoom - 1) * 100)).toString();
	}

	zoomInDisabled() {
		return this.currentZoom >= SvgZoomParams.MAX;
	}

	zoomOutDisabled() {
		return this.currentZoom <= SvgZoomParams.MIN;
	}

	onClose() {
		this.crmService.sendCloseRequest();
	}

	onUndo() {
		this.undoClick.emit(false);
	}

	onRedo() {
		this.redoClick.emit();
	}

	onRewind(){
		this.undoClick.emit(true);
	}

	get isLocalhost() {
		return environment.localhost;
	}
	get currLng(): string {
		return window.document.documentElement.lang;
	}

	selectedBar(bar: IBarLine){
		bar.selected = true;
		this.barLines.forEach(b => {
			if(b.side == bar.side && b.barId != bar.barId){
				b.selected = false;
			}
		});

		this.barSelection.emit(bar);
	}

	changeLayer(layer: string) {
		var l = this[layer] as boolean;
		console.debug("Layer " + layer + " value is " + l);
		this[layer] = !l;
		var lvls: LayerLevel[] = [LayerLevel.Construction];
		if (this.layerInside == true) {
			lvls.push(LayerLevel.Inside);
		}
		if (this.layerMiddle == true) {
			lvls.push(LayerLevel.Middle);
		}
		if (this.layerOutside == true) {
			lvls.push(LayerLevel.Outside);
		}
		this.projectService.layersChanged.next(lvls);
	}

	changeDimensions() {
		this.layerDimensions = !this.layerDimensions;
		this.projectService.showDimensionsSubj.next(this.layerDimensions);
	}

	@ViewChild("anchor1", { read: ElementRef }) public anchor1: ElementRef;
	@ViewChild("popup1", { read: ElementRef }) public popup1: ElementRef;
	@ViewChild("anchor2", { read: ElementRef }) public anchor2: ElementRef;
	@ViewChild("popup2", { read: ElementRef }) public popup2: ElementRef;

	@HostListener("document:keydown", ["$event"])
	public keydown(event: KeyboardEvent): void {
		if (event.code === "Escape") {
			this.showValidationPopup = false;
		}
	}

	@HostListener("document:click", ["$event"])
	public documentClick(event: KeyboardEvent): void {
		if(!this.containsValidation(event.target)){
			this.showValidationPopup = false;
		}
	}

	private containsValidation(target: EventTarget): boolean {
		return ( this.anchor2.nativeElement.contains(target) || (this.popup2 ? this.popup2.nativeElement.contains(target) : false));
	}

	get showUploadButton(): boolean {
		const mode = this.projectService.appMode;
		return mode === AppMode.B2B || mode === AppMode.Link;
	}

	get exportToCRMLabel(): string {
		if (this.projectService.isValid) {
			if((this.projectService.readOnly && this.crmService.isCrmPresent) || !this.crmService.isCrmPresent){
				return $localize`:Toolbar|'Export to CRM' button tooltip:Export to CRM`;
			} else {
				return $localize`:Toolbar|'Export to CRM' button tooltip:Project is editable, export is disabled`;
			}
		} else {
			return $localize`:Toolbar|'Export to CRM' button disabled tooltip:Project is not valid, export is disabled`;
		}
	}

}
